/**
 * Extrai scripts disponíveis de uma versão
 */
export function extrairScriptsDaVersao(versao) {
  const scripts = versao?.versao?.detalhes?.flatMap((detalhe) =>
    detalhe?.motores?.map((motor) => motor?.script).filter(Boolean)
  ) || [];
  
  // Verificar se tem resumo E valores salvos no JSONB
  const temResumo = versao?.versao?.resumo === true;
  const valoresResumo = versao?.versao?.valores_resumo || {};
  const temValoresSalvos = Object.keys(valoresResumo).length > 0;
  
  // Só adicionar RESUMO_GERAL se tiver resumo E valores salvos
  if (temResumo && temValoresSalvos) {
    scripts.push("RESUMO_GERAL");
  }
  
  return scripts;
}

/**
 * Busca motor por script em uma versão
 */
export function buscarMotorPorScript(versao, script) {
  if (!script) return null;
  for (const detalhe of versao?.versao?.detalhes || []) {
    const encontrado = detalhe?.motores?.find((motor) => motor?.script === script);
    if (encontrado) {
      return encontrado;
    }
  }
  return null;
}

/**
 * Normaliza lista de versões adicionando scripts disponíveis e statusProjeto
 */
export function normalizarVersoes(versoes) {
  return (versoes || []).map((versao) => {
    const scripts = extrairScriptsDaVersao(versao);
    return {
      ...versao,
      scriptsDisponiveis: new Set(scripts),
      // Preservar statusProjeto da API (pode ser null, 'NULL', 'EM_ANALISE', 'APROVADO', 'REJEITADO')
      statusProjeto: versao.statusProjeto || null,
    };
  });
}

/**
 * Verifica se uma versão é projeto (statusProjeto existe e não é NULL)
 */
export function verificarSeVersaoEProjeto(versao) {
  return versao?.statusProjeto !== null && versao?.statusProjeto !== 'NULL' && versao?.statusProjeto !== undefined;
}

/**
 * Verifica se uma versão está bloqueada (EM_ANALISE ou APROVADO)
 */
export function verificarSeVersaoEstaBloqueada(versao) {
  return versao?.statusProjeto === 'EM_ANALISE' || versao?.statusProjeto === 'APROVADO';
}

/**
 * Verifica se uma prévia está bloqueada (qualquer versão EM_ANALISE ou APROVADO)
 */
export function verificarSePreviaEstaBloqueada(versoes, previaInfo = null) {
  // Se tiver informação direta da prévia, usar ela prioritariamente
  if (previaInfo?.status === 'EM_ANALISE' || previaInfo?.status === 'APROVADO' || previaInfo?.status === 'PROJETO-INICIADO' || previaInfo?.status === 'PROJETO-APROVADO' || previaInfo?.status === 'PREVIA-CANCELADA') {
    return true;
  }
  
  // Fallback para verificação nas versões
  if (!Array.isArray(versoes) || versoes.length === 0) return false;
  
  return versoes.some(v => 
    v.statusProjeto === 'EM_ANALISE' || v.statusProjeto === 'APROVADO'
  );
}

/**
 * Verifica se uma versão está liberada (REJEITADO ou NULL)
 */
export function verificarSeVersaoEstaLiberada(versao) {
  return versao?.statusProjeto === 'REJEITADO' || 
         versao?.statusProjeto === null || 
         versao?.statusProjeto === 'NULL' ||
         versao?.statusProjeto === undefined;
}

